var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_158)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_123_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9535 84.5283C89.9535 90.4116 72.1169 95.2054 50.1092 95.2054C28.1014 95.2054 10.2648 90.4427 10.2648 84.5283C10.2648 78.6451 28.1014 73.8513 50.1092 73.8513C72.1169 73.8513 89.9224 78.6451 89.9535 84.5283Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2882 73.042C24.4282 67.5011 23.6811 49.4466 32.6773 38.3338C37.1286 33.0108 38.2804 29.3066 38.6228 24.2949C38.8718 18.5984 34.6072 1.63341 50.6695 0.357142C66.9496 -0.950251 66.0469 15.112 65.9535 23.6101C65.8913 30.7696 71.2142 34.8474 74.8874 40.4505C81.6422 50.7229 81.0819 68.4038 73.6111 77.9914C64.1481 89.9758 56.0547 84.7774 50.6695 85.2132C40.5839 85.8046 40.2415 91.1587 28.2882 73.042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5722 41.5089C70.3738 44.0925 77.6267 55.6412 66.1403 62.863C62.0936 65.3844 69.7512 74.9719 73.4243 70.3338C79.9302 61.9914 75.7901 48.6684 71.8679 43.9058C69.2531 40.5439 65.2064 39.2365 67.5722 41.5089Z",
    fill: "url(#paint0_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.794 39.9525C71.401 43.6879 79.7746 56.7618 67.5411 65.291C63.5255 67.9369 71.0897 76.3104 75.3543 72.0459C90.1403 57.1665 74.9808 40.077 69.7512 34.1937C65.0819 29.0575 60.9419 35.3766 66.794 39.9525Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.9773
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1636 8.48165C60.008 12.7462 55.3076 16.4505 49.6734 16.7929C44.0391 17.1353 39.6189 13.898 39.7745 9.6334C39.9302 5.36881 44.6306 1.66453 50.2648 1.32212C55.8991 1.01083 60.3193 4.21706 60.1636 8.48165Z",
    fill: "url(#paint1_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6851 18.6295C46.8407 21.3999 45.5333 23.7346 43.7279 23.828C41.9224 23.9213 40.3349 21.7735 40.1792 19.0031C40.0236 16.2326 41.331 13.898 43.1364 13.8046C44.9419 13.7112 46.5294 15.8591 46.6851 18.6295Z",
    fill: "url(#paint2_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9535 18.8474C50.0158 22.0536 52.1014 24.6062 54.5917 24.5439C57.0819 24.4817 59.043 21.8357 58.9808 18.5984C58.9185 15.3922 56.8329 12.8396 54.3426 12.9019C51.8524 12.9641 49.8601 15.6412 49.9535 18.8474Z",
    fill: "url(#paint3_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.008 19.5634C51.9769 21.3377 52.8485 22.7696 54.0002 22.7696C55.1208 22.7696 56.0858 21.3377 56.117 19.5945C56.1481 17.8202 55.2765 16.3883 54.1247 16.3883C52.973 16.3883 52.0391 17.8202 52.008 19.5634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8173 19.5945C44.973 21.0575 44.4127 22.3027 43.6033 22.4272C42.794 22.5206 42.0158 21.4311 41.8601 19.968C41.7045 18.505 42.2648 17.2599 43.0742 17.1354C43.8835 17.042 44.6617 18.1315 44.8173 19.5945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4749 18.5673C52.3815 19.5634 52.8485 20.3727 53.5022 20.435C54.1559 20.4972 54.7784 19.719 54.8718 18.754C54.9652 17.7579 54.4983 16.9486 53.8446 16.8863C53.1909 16.8241 52.5683 17.6023 52.4749 18.5673Z",
    fill: "url(#paint4_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1325 18.8163C44.2259 19.6256 43.8835 20.3416 43.3854 20.4038C42.8874 20.4661 42.4205 19.8435 42.3271 19.0031C42.2337 18.1937 42.5761 17.4778 43.0742 17.4155C43.5722 17.3533 44.0391 18.007 44.1325 18.8163Z",
    fill: "url(#paint5_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3271 49.3844C36.5372 44.3727 41.2376 35.5634 41.331 28.7462C41.331 23.3299 57.5489 22.0225 58.8563 27.4388C60.1636 32.8552 63.4633 40.9486 65.58 44.8708C67.6967 48.7618 73.829 61.182 67.2921 72.0147C61.4088 81.6023 43.5722 89.1976 34.0469 70.7073C30.8096 64.2949 31.401 56.3571 34.3271 49.3844Z",
    fill: "url(#paint6_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3349 45.649C30.436 49.2287 26.5138 58.6295 36.1014 63.7657C46.4049 69.2443 46.3738 80.4816 33.9847 75.1276C22.6539 70.3027 27.6656 50.754 30.8407 46.0848C32.8952 42.8163 36.008 38.8007 32.3349 45.649Z",
    fill: "url(#paint7_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9535 41.6023C30.9341 46.5206 23.7123 58.1003 33.3932 64.1392C46.4049 72.1392 42.7317 80.1081 30.8407 72.9174C14.0936 62.8941 28.8173 42.6606 35.5099 34.9408C43.1675 26.2871 36.973 36.5283 33.9535 41.6023Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2765 51.2832C63.2765 56.7618 58.0158 63.8591 48.9885 63.7968C39.6812 63.8591 35.7278 56.7618 35.7278 51.2832C35.7278 45.8046 41.8913 41.3532 49.4866 41.3532C57.1131 41.3844 63.2765 45.8046 63.2765 51.2832Z",
    fill: "url(#paint8_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3582 34.0692C58.2648 39.7346 54.5605 41.0731 49.8913 41.0731C45.222 41.0731 41.829 40.2326 41.4243 34.0692C41.4243 30.2093 45.222 27.968 49.8913 27.968C54.5605 27.9369 58.3582 30.1781 58.3582 34.0692Z",
    fill: "url(#paint9_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1247 42.7851C33.1753 38.147 39.6189 31.0186 31.3387 43.7813C24.615 54.3027 28.8485 61.0575 31.0275 62.9252C37.3154 68.5283 37.0664 72.2949 32.117 69.3377C21.5022 63.0186 23.7123 52.3727 30.1247 42.7851Z",
    fill: "url(#paint10_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2959 44.684C71.65 39.2365 63.2454 25.4155 74.7006 41.4778C85.1286 56.0147 77.8134 66.1315 76.5061 67.1276C75.1987 68.1237 70.8096 70.147 72.0858 66.6295C73.3932 63.112 79.8679 56.4505 74.2959 44.684Z",
    fill: "url(#paint11_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8212 87.6412C20.8485 83.9369 10.7317 88.3571 14.4049 78.3338C15.152 76.0614 13.3154 72.6373 14.4983 70.4272C15.8991 67.719 18.9185 68.3104 20.724 66.505C22.4983 64.6373 23.6189 61.3999 26.9496 61.898C30.2493 62.396 32.4594 66.4427 34.7629 71.4233C36.4749 74.9719 42.5138 79.9836 42.1092 83.968C41.6111 90.0692 34.6695 91.2209 27.8212 87.6412Z",
    fill: "url(#paint12_linear_123_158)",
    stroke: "#E68C3F",
    strokeWidth: 6.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5917 64.1081C77.5333 66.1003 73.1131 69.3066 70.1559 68.4661C67.1675 67.6568 65.7979 63.112 66.3893 59.6568C66.9496 55.7968 70.1559 55.5789 74.2026 57.5089C78.5605 59.6568 79.8679 61.4622 78.5917 64.1081Z",
    fill: "url(#paint13_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1636 85.9291C81.2687 79.7346 92.6306 81.0108 84.973 72.5128C83.3543 70.6762 83.8524 66.754 81.8601 65.0731C79.5255 63.0186 76.9419 64.6996 74.5761 63.6412C72.2103 62.4894 69.7201 60.2793 66.8251 61.8357C63.9302 63.4233 63.6189 67.5322 63.3387 72.9486C63.0897 76.8396 59.5411 83.3455 61.4399 86.9252C64.1792 92.4661 71.3076 91.719 76.1636 85.9291Z",
    fill: "url(#paint14_linear_123_158)",
    stroke: "#E68C3F",
    strokeWidth: 6.2507
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9535 77.649C81.8602 65.9758 75.9769 66.0692 73.9847 65.1665C71.9924 64.2326 69.9068 62.396 67.5722 63.6723C65.2376 64.9797 65.1131 68.3416 65.0508 72.7618C64.9574 75.9369 62.3115 81.2598 63.8991 84.217C65.829 87.6723 70.4983 82.6606 73.9535 77.649Z",
    fill: "url(#paint15_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2026 79.3299C14.3738 71.6723 19.9146 69.0575 21.6889 67.8435C23.8368 66.2871 23.8679 63.2988 26.5138 63.5789C29.1598 63.8591 30.7162 67.1276 32.4905 71.1742C33.7979 74.0692 38.3426 77.9291 38.0002 81.2598C37.5644 85.182 31.3076 82.5984 26.2026 79.3299Z",
    fill: "url(#paint16_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9068 64.0147C76.973 65.6334 73.1753 68.1859 70.6539 67.5011C68.0703 66.8474 66.8874 63.2054 67.4166 60.4661C67.8835 57.3533 70.6539 57.1976 74.1403 58.754C77.8446 60.435 78.9963 61.8669 77.9068 64.0147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3543 63.112C74.7629 64.2326 72.2726 66.007 70.5294 65.54C68.7862 65.0731 67.9146 62.5517 68.1948 60.6529C68.4438 58.505 70.3115 58.3805 72.6773 59.4388C75.2298 60.6217 76.0391 61.6178 75.3543 63.112Z",
    fill: "url(#paint17_linear_123_158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1675 22.4894C44.4127 21.3377 47.4321 17.8202 53.1598 21.4933C54.2181 22.1781 55.0897 22.2404 57.1131 23.112C61.1909 24.7929 59.2609 28.8396 54.903 30.2093C53.0352 30.8007 51.3543 33.0731 47.9925 32.8552C45.0975 32.6996 44.3504 30.8007 42.5761 29.7735C39.4321 27.9992 38.9652 25.6023 40.6773 24.326C42.3893 23.0497 43.043 22.5828 43.1675 22.4894Z",
    fill: "url(#paint18_linear_123_158)",
    stroke: "#E68C3F",
    strokeWidth: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1753 25.7579C55.4633 25.8513 51.759 29.5556 47.8679 29.5556C43.9769 29.5556 41.6423 25.9447 41.0508 25.9447",
    stroke: "#E68C3F",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0975 22.1781C45.7201 21.6178 47.6812 20.0925 50.2648 21.649C50.8251 21.9603 51.3854 22.3027 52.1948 22.7696C53.8446 23.7346 53.0352 25.1353 51.043 26.0069C50.1403 26.3805 48.6461 27.1898 47.5255 27.1276C46.2804 27.003 45.4399 26.1937 44.6306 25.6645C43.1053 24.6684 43.1987 23.828 43.9146 23.1743C44.4438 22.6762 45.0352 22.2093 45.0975 22.1781Z",
    fill: "url(#paint19_linear_123_158)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_123_158",
    x: -2.73518,
    y: 60.8513,
    width: 105.689,
    height: 47.3541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_123_158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_158",
    x1: 70.7364,
    y1: 76.3507,
    x2: 72.7801,
    y2: 53.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_123_158",
    x1: 50.8679,
    y1: 1.67427,
    x2: 49.8928,
    y2: 15.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_123_158",
    x1: 43.5536,
    y1: 22.6522,
    x2: 42.953,
    y2: 14.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_123_158",
    x1: 54.4595,
    y1: 22.8554,
    x2: 54.4593,
    y2: 14.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_123_158",
    x1: 53.7678,
    y1: 16.9931,
    x2: 53.3565,
    y2: 20.1932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_123_158",
    x1: 43.1489,
    y1: 17.5755,
    x2: 43.5917,
    y2: 20.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_123_158",
    x1: 51.0383,
    y1: 76.1238,
    x2: 51.0383,
    y2: 47.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_123_158",
    x1: 35.8439,
    y1: 76.5285,
    x2: 28.5525,
    y2: 51.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_123_158",
    x1: 49.4585,
    y1: 44.3223,
    x2: 49.5316,
    y2: 62.6018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_123_158",
    x1: 49.8789,
    y1: 32.8596,
    x2: 49.9601,
    y2: 40.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_123_158",
    x1: 30.25,
    y1: 37.3456,
    x2: 30.25,
    y2: 64.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_123_158",
    x1: 74.5093,
    y1: 34.7405,
    x2: 74.4994,
    y2: 58.8407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_123_158",
    x1: 28.8651,
    y1: 75.4537,
    x2: 24.9095,
    y2: 89.1849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_123_158",
    x1: 72.9599,
    y1: 73.8869,
    x2: 72.3948,
    y2: 48.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_123_158",
    x1: 69.038,
    y1: 71.3029,
    x2: 79.8084,
    y2: 86.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_123_158",
    x1: 72.0729,
    y1: 59.4268,
    x2: 68.392,
    y2: 77.4461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_123_158",
    x1: 28.0001,
    y1: 63.8684,
    x2: 28.7276,
    y2: 84.0853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_123_158",
    x1: 71.3848,
    y1: 59.0996,
    x2: 72.2372,
    y2: 65.1491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_123_158",
    x1: 49.4737,
    y1: 22.1529,
    x2: 49.5448,
    y2: 32.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_123_158",
    x1: 48.2646,
    y1: 21.147,
    x2: 48.2453,
    y2: 26.7718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.b98ab23cb24094de4d9e87caea4f9162.svg";
export { ForwardRef as ReactComponent };